import {useEffect, useRef} from 'react';

export const NOT_IN_TAB_BUT_IN_ARROW_ORDER = -1;
export const NEITHER_IN_TAB_NOR_IN_ARROW_ORDER = -2;

export function useGroupedFocus() {
    const containerRef = useRef(null);


    useEffect(() => {
        const container = containerRef.current;
        let currentChildIndex = null;

        if (!container) return;

        const focusableSelector = '[tabindex="' + NOT_IN_TAB_BUT_IN_ARROW_ORDER + '"]';

        const focusableChildren = Array.from(container.querySelectorAll(focusableSelector));

        const handleKeyDown = (e) => {
            switch (e.key) {
                case "ArrowRight":
                    e.preventDefault();
                    increaseIndex()
                    focusableChildren[currentChildIndex]?.focus();
                    break;

                case "ArrowLeft":
                    e.preventDefault();
                    decreaseIndex();
                    focusableChildren[currentChildIndex]?.focus();
                    break;

                case "Tab":
                    currentChildIndex = null;
                    break;

                default:
                    break;
            }
        };

        const increaseIndex = () => {
            if (currentChildIndex === null){
                currentChildIndex = 0;
            } else {
                currentChildIndex = (currentChildIndex + 1) % focusableChildren.length;
            }
        };

        const decreaseIndex = () => {
            if (currentChildIndex === null){
                currentChildIndex = focusableChildren.length - 1;
            } else {
                currentChildIndex = (currentChildIndex - 1 + focusableChildren.length) % focusableChildren.length;
            }
        };

        container.addEventListener("keydown", handleKeyDown);

        return () => {
            container.removeEventListener("keydown", handleKeyDown);
        };
    }, []);

    return containerRef;
}